import type { Dispatch, SetStateAction } from 'react';

export const presets = [
  { id: 'small', label: '小（ハブ・ロビー）', cores: 2, memoryMb: 6144, heapMb: 4096, dataDiskGb: 30 },
  { id: 'medium', label: '中（サバイバル）', cores: 4, memoryMb: 12288, heapMb: 9216, dataDiskGb: 60 },
  { id: 'large', label: '大（Mod 入り）', cores: 6, memoryMb: 20480, heapMb: 16384, dataDiskGb: 100 },
] as const;

export type CreateResources = {
  cores: number;
  memoryMb: number;
  heapMb: number;
  heapMinMb: number;
  dataDiskGb: number;
};

export function CreateResourceFields({
  presetId,
  choosePreset,
  custom,
  setCustom,
}: {
  presetId: string;
  choosePreset: (id: string) => void;
  custom: CreateResources;
  setCustom: Dispatch<SetStateAction<CreateResources>>;
}) {
  return (
    <section className="card card-body stack">
      <h2>大きさ</h2>
      <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
        {presets.map((p) => (
          <label
            key={p.id}
            className={`card card-body check${presetId === p.id ? ' selected' : ''}`}
            style={{ alignItems: 'flex-start' }}
          >
            <input type="radio" name="preset" checked={presetId === p.id} onChange={() => choosePreset(p.id)} />
            <span>
              <strong>{p.label}</strong>
              <br />
              <span className="small muted">
                {p.cores} コア ・ メモリ {p.memoryMb / 1024}GB（ヒープ {p.heapMb / 1024}GB）・ ディスク {p.dataDiskGb}
                GB
              </span>
            </span>
          </label>
        ))}
        <label className={`card card-body check${presetId === 'custom' ? ' selected' : ''}`}>
          <input type="radio" name="preset" checked={presetId === 'custom'} onChange={() => choosePreset('custom')} />
          <strong>カスタム</strong>
        </label>
      </div>
      {presetId === 'custom' && (
        <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))' }}>
          {(
            [
              ['cores', 'CPU コア', 1],
              ['memoryMb', 'VM メモリ (GB)', 1],
              ['dataDiskGb', 'データディスク (GB)', 10],
            ] as const
          ).map(([key, label, step]) => (
            <div className="field" key={key}>
              <label htmlFor={`res-${key}`}>{label}</label>
              <input
                id={`res-${key}`}
                className="input"
                type="number"
                min={step}
                step={step}
                value={key === 'memoryMb' ? custom[key] / 1024 : custom[key]}
                onChange={(e) =>
                  setCustom({
                    ...custom,
                    [key]: key === 'memoryMb' ? Math.round(Number(e.target.value) * 1024) : Number(e.target.value),
                  })
                }
              />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
